/* eslint-disable prettier/prettier */

import { useEffect, useState } from 'react';

import {
	userService,
	CoachActionCenter,
	CoachRecentActivityResponse,
	CoachLearnerOverview,
} from '../services/userService';

export function useCoachActionCenter(courseid?: string, page = 1, limit = 20) {
	/* ================= ACTION CENTER ================= */

	const [data, setData] = useState<CoachActionCenter | null>(null);

	const [loading, setLoading] = useState(false);

	const [error, setError] = useState<string | null>(null);

	const fetchActionCenter = async () => {
		try {
			setLoading(true);
			setError(null);

			const response = await userService.getCoachActionCenter();

			setData(response);
		} catch (err: any) {
			setError(err.message || 'Failed to fetch coach action center');
		} finally {
			setLoading(false);
		}
	};

	/* ================= RECENT ACTIVITY ================= */

	const [recentActivityData, setRecentActivityData] =
		useState<CoachRecentActivityResponse | null>(null);

	const [recentActivityLoading, setRecentActivityLoading] = useState(false);

	const [recentActivityError, setRecentActivityError] = useState<
		string | null
	>(null);

	const fetchRecentActivity = async () => {
		try {
			setRecentActivityLoading(true);
			setRecentActivityError(null);

			const response = await userService.getCoachRecentActivity(
				page,
				limit
			);

			setRecentActivityData(response);
		} catch (err: any) {
			setRecentActivityError(
				err.message || 'Failed to fetch coach recent activity'
			);
		} finally {
			setRecentActivityLoading(false);
		}
	};

	/* ================= LEARNER OVERVIEW ================= */

	const [learnerOverviewData, setLearnerOverviewData] =
		useState<CoachLearnerOverview | null>(null);

	const [learnerOverviewLoading, setLearnerOverviewLoading] = useState(false);

	const [learnerOverviewError, setLearnerOverviewError] = useState<
		string | null
	>(null);

	const fetchLearnerOverview = async () => {
		try {
			setLearnerOverviewLoading(true);
			setLearnerOverviewError(null);

			const response = await userService.getCoachLearnerOverview(
				courseid,
				page,
				limit
			);

			setLearnerOverviewData(response);
		} catch (err: any) {
			setLearnerOverviewError(
				err.message || 'Failed to fetch learner overview'
			);
		} finally {
			setLearnerOverviewLoading(false);
		}
	};

	/* ================= USE EFFECT ================= */

	useEffect(() => {
		fetchActionCenter();
		fetchRecentActivity();
		fetchLearnerOverview();
	}, [courseid, page, limit]);

	return {
		/* Action Center */
		data,
		loading,
		error,
		refetch: fetchActionCenter,

		/* Recent Activity */
		recentActivityData,
		recentActivityLoading,
		recentActivityError,
		refetchRecentActivity: fetchRecentActivity,

		/* Learner Overview */
		learnerOverviewData,
		learnerOverviewLoading,
		learnerOverviewError,
		refetchLearnerOverview: fetchLearnerOverview,
	};
}
